
export const ChangeIsRtl = (val) => {
        return ({
            type: 'SET_ISRTL',
            value: {
                val: val
            }
        })
}


export const ChangeIsMobile = (val) => {
    return ({
        type: 'SET_ISMOBILE',
        value: {
            val: val
        }
    })
}
export const ChangeLang = (val) => {
    return ({
        type: 'SET_LANG',
        value: {
            val: val
        }
    })
}


export const ChangeActiveTab = (val) => {
    return ({
        type: 'CHANGE_ACTIVE_TAB',
        value: {
            val: val
        }
    })
}
export const SetFixed = (val) => {
    return ({
        type: 'SET_FIXED',
        value: {
            val: val
        }
    })
}
export const SetShowSearchBox = (val) => {
    return ({
        type: 'SET_SHOW_SEARCH_BOX',
        value: {
            val: val
        }
    })
}
export const SetStartDate = (val) => {
    return ({
        type: 'SET_START_DATE',
        value: {
            val: val
        }
    })
}
export const SetEndDate = (val) => {
    return ({
        type: 'SET_END_DATE',
        value: {
            val: val
        }
    })
}
export const SetGuestsList = (val) => {
    return ({
        type: 'SET_GUESTS_LIST',
        value: {
            val: val
        }
    })
}
export const ChangeGuestCount = (index, tempCount) => {
    return ({
        type: 'CHANGE_GUEST_COUNT',
        value: {
            index: index,
            tempCount: tempCount
        }
    })
}

export const SetSearchArea = (val) => {
    return ({
        type: 'SET_SEARCH_AREA',
        value: {
            val: val
        }
    })
}
export const SetPropertyType = (val) => {
    return ({
        type: 'SET_PROPERTYTYPE',
        value: {
            val: val
        }
    })
}
export const SetPropertyListing = (val) => {
    return ({
        type: 'SET_PROPERTYLISTING',
        value: {
            val: val
        }
    })
}
export const SetActiveIndex = (val) => {
    return ({
        type: 'SET_ACTIVE_INDEX',
        value: {
            val: val
        }
    })
}
export const SetMaxPrice = (val) => {
    return ({
        type: 'SET_MAX_PRICE',
        value: {
            val: val
        }
    })
}
export const SetMinPrice = (val) => {
    return ({
        type: 'SET_MIN_PRICE',
        value: {
            val: val
        }
    })
}
export const SetCurrencyRatio = (val) => {
    return ({
        type: 'SET_CURRENCY_RATIO',
        value: {
            val: val
        }
    })
}